<template>
  <van-image-preview 
    v-model="open" 
    :images="images" 
    :loop="loop"
    class="ceshi"
    :overlay-style="{
      zIndex: '99999 !important'
    }"
    @change="onChange"
  >
    <template v-slot:index>第{{ index+1 }}页</template>
  </van-image-preview>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  components:{
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data(){
    return {
      open: false,
      index: 0,
      images: [],
      // 是否开启循环播放
      loop:false,
    }
  },
  methods:{
    show(options){
      if(!options || !options.images || !Array.isArray(options.images) || !options.images.length) return false;
      this.images = options.images;
      if(options.index) {
        if(typeof options.index === "string") {
          let index = options.images.findIndex(findItem=>findItem === options.index);
          this.index = ~index ? index : 0;
        }else if(typeof options.index === "number") this.index = options.index >= 0  && options.index < options.images.length ? options.index : 0;
      };
      this.loop = Boolean(options.loop);
      this.open = true;
    },
    onChange(index) {
      this.index = index;
    },
  }
}
</script>

<style scoped lang="scss">
  ::v-deep.van-image-preview {
    z-index: 99999 !important;
  }
</style>